import React, { useEffect } from 'react';
import { DescriptionItem, Iframe, DescriptionList } from '@gogame/components';
import { defaultBaseURL } from 'api';
import { useAccessToken } from 'Auth';
import { useMountedState } from '@gogame/hooks-ts';

export default ({ invoices, senderEmail }) => {
  const [accessToken, setAccessToken] = useMountedState();
  const getAccessToken = useAccessToken();
  const invoice = invoices?.[0];

  useEffect(() => {
    getAccessToken().then(setAccessToken);
  }, []);

  if (!invoice || !accessToken) {
    return null;
  }
  return (
    <React.Fragment>
      <DescriptionList
        disableGutters={true}
        data={{ senderEmail }}
        stripEmpty={true}
      >
        <DescriptionItem
          label={'Sender email'}
          type={'link'}
          field={'senderEmail'}
          href={`mailto:${senderEmail}`}
        />
      </DescriptionList>
      <Iframe
        src={`${defaultBaseURL}/api/financial-results/invoices/${invoice.id}/preview?access_token=${accessToken}`}
        width={'100%'}
        height={'calc(100vh - 192px)'}
        style={{ paddingTop: '16px' }}
      />
    </React.Fragment>
  );
};
